import { render } from "./EmptyState.vue?vue&type=template&id=4d03de5f"
import script from "./EmptyState.vue?vue&type=script&setup=true&lang=js"
export * from "./EmptyState.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/ui/EmptyState.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4d03de5f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4d03de5f', __exports__)) {
    api.reload('4d03de5f', __exports__)
  }
  
  module.hot.accept("./EmptyState.vue?vue&type=template&id=4d03de5f", () => {
    api.rerender('4d03de5f', render)
  })

}


export default __exports__